import type { IconSvgObject } from './types';

const FocusPointIcon: IconSvgObject = [
  ["path", { d: "M8.5 2.5L4.49996 2.50007C3.39541 2.50009 2.5 3.39552 2.5 4.50007V7.5M15.5 2.5H19.5001C20.6046 2.5 21.5001 3.39545 21.5001 4.50004L21.5 7.5M15.5 21.5L19.5 21.5001C20.6046 21.5002 21.5001 20.6047 21.5001 19.5001L21.5 16.5M8.5 21.5H4.50092C3.39659 21.5 2.50126 20.6049 2.50092 19.5006L2.5 16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 7H12.5M11.5 12H12.5M11.5 17H12.5M5 12H6M18 12H19", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default FocusPointIcon;
